export function getCurrentUrl(pathname: string) {
  return pathname.split(/[?#]/)[0]
}

export function checkIsActive(pathname: string, url: string, subMenus?: string[]) {
  const current = getCurrentUrl(pathname)

  if (!current || !url) {
    return false
  }

  if (subMenus && subMenus.some((a: string) => a?.includes(pathname))) return true;

  if (current === url || current.startsWith(url)) {
    return true
  }

  if (current.indexOf(url) > -1) {
    return true
  }

  if (subMenus && subMenus.some((subMenu: string) => pathname.startsWith(subMenu))) {
    return true; 
  }

  return false
}
